import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGroupTypes, createGroupType } from "../service/groupTypeService";
import type { AcademicGroupType, CreateAcademicGroupTypePayload } from "../types";

export const loadGroupTypes = createAsyncThunk("academicGroupTypes/loadGroupTypes", async () => {
  const data = await fetchGroupTypes();
  return data;
});

export const addGroupType = createAsyncThunk(
  "academicGroupTypes/addGroupType",
  async (payload: CreateAcademicGroupTypePayload) => {
    const data = await createGroupType(payload);
    return data;
  }
);

interface GroupTypeState {
  groupTypes: AcademicGroupType[];
  loading: boolean;
  error: string | null;
}

const initialState: GroupTypeState = {
  groupTypes: [],
  loading: false,
  error: null,
};

const groupTypeSlice = createSlice({
  name: "academicGroupTypes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadGroupTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadGroupTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.groupTypes = action.payload;
      })
      .addCase(loadGroupTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to load group types";
      })
      .addCase(addGroupType.fulfilled, (state, action) => {
        state.groupTypes.push(action.payload);
      })
      .addCase(addGroupType.rejected, (state, action) => {
        state.error = action.error.message ?? "Failed to add group type";
      });
  },
});

export default groupTypeSlice.reducer;